// MUI components
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomButton from 'components/Button/CustomButton';

export const UploadFileButton = styled(CustomButton)(() => ({
  borderRadius: '6px',
  padding: '10px 12px',
  height: 44,
  width: '100%',
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '100%',
  letterSpacing: 0,
}));

export const FileItem = styled(Box)(() => ({
  padding: '10px 12px',
  height: 44,
  width: '100%',
  fontWeight: 600,
  fontSize: 14,
}));

export const ActionItemIcon = styled(Box, {
  shouldForwardProp: (prop) => !['bgcolor', 'svgdimensions'].includes(prop),
})(({ bgcolor, svgdimensions = {} }) => ({
  marginRight: 10,
  backgroundColor: bgcolor,
  height: '28px',
  width: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  gap: '10px',
  '& > svg': {
    ...svgdimensions,
  },
}));

export const FileItemContainer = styled(Box)(() => ({
  height: 44,
  width: '100%',
  borderRadius: 8,
  padding: 8,
  gap: 10,
  border: '1px solid rgba(224, 224, 224, 1)',
  marginTop: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& .FileName': {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '100%',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
    whiteSpace: 'pre',
    overflow: 'hidden',
    marginTop: 0,
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },

  '&:hover': {
    '& .FileName': {
      textDecoration: 'underline',
    },
  },

  '& .cancelIcon': {
    cursor: 'pointer',
    color: 'rgba(239, 83, 80, 1)',
  },

  '& .downloadBtn': {
    display: 'none',
    '&:hover': {
      background: 'transparent',
    },
    fontWeight: 500,
    fontSize: 13,
    lineHeight: '100%',
    letterSpacing: 0,
    transition: 'all 0.3s ease',
    '& path': {
      fill: 'rgba(78, 72, 250, 1)',
    },
  },
}));

export const LoadingFileItemContainer = styled(Box)(() => ({
  height: 44,
  width: '100%',
  borderRadius: 8,
  padding: 8,
  backgroundColor: 'rgba(242, 241, 255, 1)',
  gap: 10,
  border: '1px solid rgba(224, 224, 224, 1)',
  marginTop: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& .UploadingName': {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
    marginTop: 0,
    marginLeft: 10,
  },

  '& .cancelIcon': {
    cursor: 'pointer',
    color: 'rgba(239, 83, 80, 1)',
  },
}));
